<template>
	<BaseCatalogLists :fetch="{code: 'checkout_suggestion', use_total: true, cache_lifetime: 60, response_fields: ['code']}" v-slot="{items: list}">
		<BaseCatalogProductsWidget :fetch="{list_code: list[0].code, sort: 'cheaper', only_available: true, limit: 12, category_id: cart.product_categories}" v-slot="{items: products}" v-if="list?.length && toFree?.amount > 0 && cart?.product_categories?.length" :gtm-tracking="{item_list_id: 'checkout_suggestion', item_list_name: labels.get('free_delivery_widget_title')}" @loadProductsWidget="onLoadedProducts">
			<div class="cart_info_total_extra_shipping_to_free_box free-delivery-widget active" :class="[mode]">
				<BaseCmsLabel code="free_delivery_widget_title" class="fdw-title" tag="div" />
				<div class="fdw-note" v-html="labels.get('free_delivery_widget_note').replace('%FREE_ABOVE%', formatCurrency(toFree.above))"></div>

				<div class="fdw-container">
					<div class="slider-free-delivery">
						<CatalogSpeciallists :items="products" :perPage="3" />
					</div>
				</div>
			</div>
		</BaseCatalogProductsWidget>
	</BaseCatalogLists>
</template>

<script setup>
	const labels = useLabels();
	const {formatCurrency} = useCurrency();
	const props = defineProps(['toFree','mode','cart']);

	function onLoadedProducts(products){
		if(products?.items.length){
			sendProductImpressions(products.items, "cart_delivery");
		}
	}
</script>

<style lang="less" scoped>
	.free-delivery-widget{padding-top: 40px; display: none;
		&.active{display: block;}
	}
	.fdw-title{font-size: 34px; line-height: 44px; padding-top: 0; padding-bottom: 8px; font-weight: 300}
	.fdw-note{
		font-size: 22px; line-height: 30px; font-weight: normal;
		:deep(span){color: var(--primaryColor); font-weight: bold;}
	}
	.fdw-container{padding-top: 25px;}

	:deep(.swiper){padding-left: 1px;}
	:deep(.swiper-navigation){left: 10px; right: 10px; top: 160px;}

	@media (max-width: @t){
		.free-delivery-widget{padding-top: 30px;}
		.fdw-title{font-size: 30px; line-height: 39px; padding-bottom: 6px;}
		.fdw-note{font-size: 20px; line-height: 26px;}
		.fdw-container{padding-top: 20px;}

		:deep(.swiper-navigation){left: 5px; right: 5px; top: 95px;}
		.slider-free-delivery{
			margin-left: -4px;
			:deep(.cp-image){
				a{height: 195px; padding: 8px 8px 0;}
			}
			:deep(.cp-brand){padding: 5px 15px 3px;}
			:deep(.cp-title){font-size: 14px; line-height: 18px; padding: 0 15px 15px;}
			:deep(.cp-price){padding: 0 15px 25px;}
		}
	}
	@media (max-width: @tp){
		.free-delivery-widget{padding-top: 0;
			&.active{padding-top: 20px; width: 100%; margin-right: 32px;}
		}
		.fdw-title{font-size: 28px; line-height: 36px;}
	}
	@media (max-width: @m){
		.free-delivery-widget{
			padding-right: 15px; padding-left: 15px;
			&.active{padding-top: 25px; margin-right: 0;}
		}
		.fdw-title{font-size: 24px; line-height: 30px; max-width: 290px; font-weight: bold;}
		.fdw-note{font-size: 14px; line-height: 18px;}
		.fdw-container{padding-top: 15px;}

		.slider-free-delivery{margin-left: -16px; margin-right: -16px;}
		:deep(.swiper){padding-left: 0;}
	}
</style>